module.exports = __webpack_public_path__ + "img/PP.f78aae26.png";